import MainMenu from "./MainMenu";
import React from "react";

export default function Events() {
    return (
        <div style={{display: "flex", flexDirection: "row"}}>
            <MainMenu/>
            <div style={{width: '660px', padding: '0px 0px 0px 70px'}}>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    <img alt='game-night' src='game-night-500.jpg' width='400px' height='210px'/>
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    We are hosting GAME NIGHT on Fridays :)
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    1. Friday Game night EU: 8pm CET (central european time).
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    2. Friday Game night USA: 8pm eastern / 5pm pacific.
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    Bring your best ApexDucks and lets Race!
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    Join the discord channel here: <a target='discord' href='https://discord.gg/AXWpP9mF'>#duck-racerz</a>
                </div>
                <div style={{fontSize: '20px', marginBottom: '20px'}}>
                    Come for fun, team spirit and prizes. QUACK.
                </div>
            </div>
        </div>
    );
}
